import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";

import { getOutletIdFromBrowser } from "../utils/helpers";

export default function DatadogOutletSync() {
    const { pathname } = useLocation();

    useEffect(() => {
        const outletId = getOutletIdFromBrowser();
        if (outletId) {
            datadogRum.setGlobalContextProperty("outlet_id", outletId);
        } else {
            datadogRum.removeGlobalContextProperty("outlet_id");
        }
    }, [pathname]);

    return null;
}
